/** Steps shown in the brand panel for the public registration flow. */
export const REGISTRATION_STEPS = [
    { label: 'Your email', description: 'Where we send your confirmation and sign-in codes.' },
    { label: 'How you’re attending', description: 'Nonprofit, donor, sponsor or guest.' },
    { label: 'Your details', description: 'A few questions tailored to your registration type.' },
    { label: 'Review by our team', description: 'We confirm your registration and email you once approved.' },
];
